import React from "react";
import PropTypes from "prop-types";
import BaseEventCard from "./BaseEventCard";
import EventMetaChips from "./EventMetaChips";
import CommonEventInfoRows from "./CommonEventInfoRows";
import CapacityIndicator from "./CapacityIndicator";
import TestingRsvpChips from "./TestingRsvpChips";
import EventTagList from "./EventTagList";
import AdminEventActions from "./AdminEventActions";
import PrimaryDetailAction from "./PrimaryDetailAction";
import {
  getDateRangeLabel,
  getEventCardMetrics,
  getManageParticipantsConfig,
} from "./cardUtils";
import { eventCardShape } from "./eventPropTypes";

export default function TestingEventCardAdmin({
  event,
  canEdit,
  onEdit,
  onDelete,
  onManageParticipants,
  onDetail,
  onToggleVisibility,
  onCollectFees,
}) {
  const metrics = getEventCardMetrics(event);
  const manageConfig = getManageParticipantsConfig(event);

  return (
    <BaseEventCard
      accentColor={metrics.accentColor}
      title={event?.eventName || "Unbenannte Veranstaltung"}
      chips={
        <EventMetaChips
          event={event}
          isTesting={metrics.isTesting}
          eventTypeLabel={metrics.eventTypeLabel}
          statusLabel={metrics.statusLabel}
          statusColor={metrics.statusColor}
          accentColor={metrics.accentColor}
        />
      }
      info={
        <CommonEventInfoRows
          event={event}
          dateRange={getDateRangeLabel(event)}
          peopleLabel="Aufgestellt"
          attendeesCount={metrics.attendeesCount}
          maxParticipants={metrics.maxParticipants}
          icon="mdi:account-star"
        />
      }
      body={
        <>
          <CapacityIndicator
            attendeesCount={metrics.attendeesCount}
            maxParticipants={metrics.maxParticipants}
            capacityPercent={metrics.capacityPercent}
            isFull={metrics.isFull}
            accentColor={metrics.accentColor}
          />
          <TestingRsvpChips
            attendeesCount={metrics.attendeesCount}
            rsvpZugesagt={metrics.rsvpZugesagt}
            rsvpAbgesagt={metrics.rsvpAbgesagt}
            rsvpAusstehend={metrics.rsvpAusstehend}
          />
          <EventTagList event={event} />
        </>
      }
      primaryAction={<PrimaryDetailAction onDetail={onDetail} />}
      showManagement={canEdit}
      managementActions={
        <AdminEventActions
          event={event}
          manageConfig={manageConfig}
          onToggleVisibility={onToggleVisibility}
          onManageParticipants={onManageParticipants}
          onEdit={onEdit}
          onCollectFees={onCollectFees}
          onDelete={onDelete}
        />
      }
    />
  );
}

TestingEventCardAdmin.propTypes = {
  event: eventCardShape,
  canEdit: PropTypes.bool,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onManageParticipants: PropTypes.func,
  onDetail: PropTypes.func,
  onToggleVisibility: PropTypes.func,
  onCollectFees: PropTypes.func,
};

TestingEventCardAdmin.defaultProps = {
  event: null,
  canEdit: false,
  onEdit: undefined,
  onDelete: undefined,
  onManageParticipants: undefined,
  onDetail: undefined,
  onToggleVisibility: undefined,
  onCollectFees: undefined,
};
